<template>
    <div class="dropdown" ref="dropdownMenu">
        <button type="button" :class="triggerClass" @click="isVisible = !isVisible">
            <slot name="trigger"></slot>
        </button>
        <transition name="fade">
            <div class="dropdown-items" v-show="isVisible" transition-content>
                <slot name="items"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        triggerClass: {
            type: String,
            default: 'btn btn-sm'
        }
    },

    data() {
        return {
            isVisible: false
        }
    },

    methods: {
        documentClick(e) {
            let el = this.$refs.dropdownMenu,
                target = e.target

            if (el !== target && !el.contains(target)) {
                this.isVisible = false
            }
        }
    },

    created() {
        document.addEventListener('click', this.documentClick)
    },

    destroyed() {
        document.removeEventListener('click', this.documentClick)
    }
}
</script>
